export const SCHOOL_LOCK_START_DATE = "SchoolLockStartDate";
export const SCHOOL_LOCK_END_DATE = "SchoolLockEndDate";
export const ANDROID_APP_URL_SETTING = "ProspectLinkAndroidAppURL";
export const APPLE_APP_URL_SETTING = "ProspectLinkAppleAppURL";
